import React from 'react'

export const Imprint = () => {
  return <div className="container grid-lg ndnr-imprint">
    <div className="columns">
      <div className="column col-12 mb-2 mt-2">
        <h2 className='text-center'>Impressum & Datenschutzerklärung</h2>
        <p>
          Christian Fuchs<br/>
          c/o DIE ZEIT<br/>
          Dorotheenstraße 33<br/>
          10117 Berlin
        </p>

        <p>
          Inhaltlich Verantwortlicher gemäß § 5 TMG, § 55 II RStV:<br/>
          Christian Fuchs<br/>
          post[at]christian-fuchs.org<br/>
          Fax: 040 / 7272 - 225
        </p>

        <p>
          <strong>Haftungsausschluss:</strong><br/><br/>
          Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte
          externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber
          verantwortlich.
        </p>

        <p>
          <strong>Datenschutzerklärung:</strong>
        </p>
        <p>
          Diese Datenschutzerklärung klärt Sie über die Art, den Umfang und Zweck der Verarbeitung von personenbezogenen Daten (nachfolgend kurz „Daten“) im Rahmen der Webseite neuerechte.org (nachfolgend bezeichnet als „Onlineangebot“). Im Hinblick auf die verwendeten Begrifflichkeiten, wie z.B. „Verarbeitung“ oder „Verantwortlicher“ verweisen wir auf die Definitionen im Art. 4 der Datenschutzgrundverordnung (DSGVO).
        </p>
        <p>
          Verantwortliche i.S. Art. 4 Nr. 7 DSGVO ist Christian Fuchs. Sie erreichen ihn in Datenschutzfragen über die o.a. E-Mail-Adresse.
        </p>
        <p>
          Für das Onlineangebot verarbeiten wir selbst keine personenbezogenen Daten. Es findet keine Analyse von Nutzerverhalten statt. Es findet keine Protokollierung von Seitenaufrufen statt.
        </p>
        <p>
          <strong>Verwendete Dienstleister:</strong>
        </p>
        <p>
          Zur Bereitstellung des Onlineangebotes werden folgende Dienstleister verwendet:
          <br/><br/>
          <strong>Google Firebase Hosting:</strong>
          <br/><br/>
          Wird verwendet um das Onlineangebot über einen Browser auszuliefern. Anbieter von Google Firebase Hosting ist die Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA. Hierbei verarbeitet Google LLC verkehrsübliche Metadaten (z.B. die IP-Adresse). Der Datenschutzerklärung für Google Firebase lassen sich die Details der Verarbeitung entnehmen, u.a. zum Thema "Privacy Shield": https://firebase.google.com/support/privacy/.
          <br/><br/>
          <strong>Mapbox:</strong>
          <br/><br/>
          Wird zur Bereitstellung von Kartenfunktionen verwendet. Anbieter von Mapbox ist die Mapbox, Inc., 1714 14th Street NW, Washington, DC 20009-4309, USA. Hierbei verarbeitet Mapbox Inc. verkehrsübliche Metadaten (z.B. die IP-Adresse) an. Die Datenschutzerklärung von Mapbox erklärt die Details der Verarbeitung: https://www.mapbox.com/privacy/.
          <br/><br/>
          <strong>Google Fonts:</strong>
          <br/><br/>
          Wir binden die Schriftarten ("Google Fonts") des Anbieters Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland, ein. Nach Angaben von Google werden die Daten der Nutzer allein zu Zwecken der Darstellung der Schriftarten im Browser der Nutzer verwendet. Die Einbindung erfolgt auf Grundlage unserer berechtigten Interessen an einer technisch sicheren, wartungsfreien und effizienten Nutzung von Schriftarten, deren einheitlicher Darstellung sowie Berücksichtigung möglicher lizenzrechtlicher Restriktionen für deren Einbindung. Datenschutzerklärung: https://www.google.com/policies/privacy/.
        </p>
        <p>
          Soweit durch die o.a. Tools personenbezogene Daten verarbeitet werden, geschieht dies zu dem Zweck, Ihnen diese Webseiten bereitstellen zu können. Dies entspricht unserem berechtigten Interesse. Rechtsgrundlage für die Datenverarbeitung ist insoweit Art. 6 Abs. 1 Satz 1 Buchst. f) DSGVO.
        </p>
        <p>
          <strong>E-Mails:</strong>
        </p>
        <p>
          Personenbezogenen Daten, die uns z.B. per E-Mail mitgeteilt werden (z.B. Name, E-Mail-Adresse und/oder die Telefonnummern), verarbeiten wir nur zur Korrespondenz mit den Personen, die uns die E-Mails übersenden und nur für den Zweck, zu dem uns die Daten übermittelt wurden.
        </p>
        <p>
          Rechtsgrundlage für diese Verarbeitung ist Art. 6 Abs. 1 Satz 1 Buchst. b) der Datenschutz-Grundverordnung (DS-GVO). Liegt eine Einwilligung in die Datenverarbeitung vor, ist die Rechtsgrundlage Art. 6 Abs. 1 Satz 1 Buchst. a) DSGVO.
        </p>
        <p><strong>Kategorien von Empfängern Ihrer Daten</strong></p>
        <p>Wir übermitteln personenbezogene Daten nicht an Dritte.</p>
        <p><strong>Dauer der Speicherung / Kriterien der Speicherdauer</strong></p>
        <p>
          Wir speichern personenbezogenen Daten so lange, bis der Zweck, welcher der Verarbeitung zugrundliegt, entfallen ist. Sofern wir gesetzlich verpflichtet sind, personenbezogene Daten zu speichern, erfolgt die Speicherung für die Dauer der gesetzlichen Verpflichtung. Gegebenenfalls werden personenbezogene Daten für den laufenden Betrieb gesperrt, sofern kein anderer Zweck als die gesetzliche Verpflichtung zur Speicherung mehr für die Verarbeitung vorliegt.
        </p>
        <p><strong>Rechte der Betroffenen</strong></p>
        <p><strong>Rechte gem. Art. 15 – 18, 20 DSGVO</strong></p>
        <p>
          Betroffene Personen haben das Recht, in angemessenen Abständen von uns Auskunft über ihre gespeicherten personenbezogenen Daten zu verlangen (Art. 15 DSGVO). Auf Verlangen stellen wir eine Kopie der Daten, die Gegenstand der Verarbeitung sind, zur Verfügung.
        </p>
        <p>
          Darüber hinaus haben Betroffene das Recht, von uns die Berichtigung falsch gespeicherter Daten zu verlangen (Art. 16 DSGVO).
        </p>
        <p>
          Betroffene Personen haben außerdem das Recht, von uns die Löschung ihrer personenbezogenen Daten zu verlangen (Art. 17 DSGVO). Wir sind zur Löschung u.a. verpflichtet, wenn personenbezogene Daten für die Zwecke, für die sie erhoben oder auf sonstige Weise verarbeitet wurden, nicht mehr erforderlich sind, wenn eine einmal erteilte Einwilligung widerrufen oder die Daten unrechtmäßig verarbeitet wurden.
        </p>
        <p>
          Unter bestimmten Voraussetzungen haben betroffene Personen das Recht auf Einschränkung der Verarbeitung ihrer personenbezogenen Daten (Art. 18 DSGVO). Dazu gehört, dass sie die Richtigkeit ihrer personenbezogenen Daten bestreiten und wir den Einwand überprüfen müssen. In dem Fall dürfen personenbezogene Daten der Betroffenen von uns, mit Ausnahme der Speicherung, nicht weiterverarbeitet werden, bis die Frage der Richtigkeit geklärt ist.
        </p>
        <p>
          Darüber hinaus haben betroffene Personen das Recht, dass wir die Daten, die uns aufgrund einer Einwilligung oder aufgrund eines bestehenden Vertragsverhältnisses bereitgestellt wurden, in einem maschinenlesbaren Format an die Betroffenen herausgeben oder – nach Wahl der Betroffenen – an einen Dritten übertragen (Recht auf Datenübertragbarkeit, Art. 20 DSGVO).
        </p>
        <p>
          <strong>Keine Vertragliche oder gesetzliche Pflicht zur Bereitstellung der Daten / Folgen der Nichtbereitstellung</strong>
        </p>
        <p>
          Betroffene Personen sind vertraglich oder gesetzlich nicht verpflichtet, uns ihre personenbezogenen Daten zur Verfügung zu stellen.
        </p>
        <p><strong>Jederzeitiges Widerspruchsrecht gem. Art. 21 DSGVO</strong></p>
        <p>
          Beruht die Verarbeitung personenbezogener Daten durch uns auf der Wahrnehmung einer Aufgabe, die im öffentlichen Interesse liegt, oder erfolgt sie in der Ausübung öffentlicher Gewalt (Art. 6 Abs. 1 Satz 1 Buchst e) DSGVO) oder beruht die Datenverarbeitung auf berechtigten Interessen unsererseits, haben Betroffene das Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben, jederzeit der Verarbeitung ihrer personenbezogenen Daten zu widersprechen. Wir werden die Verarbeitung dann beenden, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die die Interessen der betroffenen Personen an der Beendigung der Verarbeitung überwiegen.
        </p>
        <p>
          Der Widerspruch gegen die Verarbeitung personenbezogener Daten zu Zwecken der Direktwerbung ist jederzeit ohne Einschränkungen möglich.
        </p>
        <p><strong>Jederzeitiges Widerrufsrecht bei Einwilligung</strong></p>
        <p>
          Beruht die Datenverarbeitung durch uns auf der Einwilligung der betroffenen Personen, haben diese das Recht, eine erteilte Einwilligung jederzeit zu widerrufen. Die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung bleibt von dem Widerruf unberührt.
        </p>
        <p><strong>Beschwerderecht bei der zuständigen Aufsichtsbehörde</strong></p>
        <p>
          Betroffene Personen haben das Recht, sich bei der für uns zuständigen Aufsichtsbehörde unter der folgenden Anschrift zu beschweren:
        </p>
        <p>
          Der Hamburgische Beauftragte für den Datenschutz<br/>
          Klosterwall 6<br/>
          20095 Hamburg<br/>
          Telefon: +49 40 428544040
        </p>
      </div>
    </div>
  </div>
}



// WEBPACK FOOTER //
// ./src/imprint.js